<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <!-- Carian Premis Section -->
    <div class="w-card__content content-hardcode">
      <div class="search-section">
        <div class="search-container">
          <h2 class="search-title">
            **Sila buat Carian ID Premis di bawah terlebih dahulu sekiranya premis telah didaftar pada sistem e-VETPERMIT
          </h2>
          
          <div class="search-input-wrapper">
            <z-input
              class="search-input bold-label"
              label="CARIAN ID PREMIS e-VETPERMIT *"
              name="premis_id"
              v-model="carian_profil.q"
            />
            <button class="search-button" @click="cariPremis">
              <w-icon>fal fa-search</w-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Form Section -->
    <z-page :title="title">
      <w-form 
        class="premis-form" 
        v-model="form.valid" 
        v-model:errors-count="form.errorsCount" 
        @validate="onValidate" 
        @success="onSuccess"
      >   
        <div class="form-grid">
          <!-- Premis Information Card -->
          <div class="form-card">
            <div class="card-header">
              <h3 class="card-title">Maklumat Premis</h3>
            </div>
            <div class="card-body">
              <w-input 
                class="form-field" 
                label="ID Premis *" 
                type="text" 
                v-model="form.no_premis" 
                disabled
              />  
              <w-input 
                class="form-field" 
                label="ID eVetPermit" 
                type="text" 
                v-model="form.no_premis_vet" 
                disabled
              />
              
              <div class="form-field">
                <div class="field-label">Kategori Premis *</div>
                <div class="field-input">
                  <w-radios
                    v-model="form.lkp_jenis_pengguna_id"
                    :items="jenis_pengguna"
                    inline
                    :validators="[validators.required]"
                  />
                </div>
              </div>
              
              <w-input 
                class="form-field" 
                label="Nama Premis *" 
                type="text" 
                v-model="form.nama" 
                :validators="[validators.required]"
              />
              <w-input 
                class="form-field" 
                label="No Telefon" 
                type="text" 
                v-model="form.no_tel" 
              />
              <z-select 
                class="form-field" 
                :items="kaedah" 
                label="Kaedah Penternakan*"  
                v-model="form.lkp_kaedah_id"  
                :validators="[validators.required]"
              />
              <w-select 
                v-if="form.id > 0"
                class="form-field" 
                :items="lkp_status" 
                label="Status Premis" 
                v-model="form.lkp_status_id" 
              />
            </div>
          </div>
          
          <!-- Premis Address Card -->
          <div class="form-card">
            <div class="card-header">
              <h3 class="card-title">Alamat Premis</h3>
            </div>
            <div class="card-body">
              <w-textarea 
                class="form-field" 
                label="Alamat *"  
                v-model="form.alamat" 
              />
              <w-input 
                class="form-field" 
                label="Poskod *" 
                name="poskod" 
                v-model="form.kode" 
                @input="getPoskodUtama()"
              />
              <z-select 
                class="form-field" 
                :items="lkp_bandar" 
                label="Mukim/Bandar/Pekan *"  
                v-model="form.lkp_bandar_id" 
                @input="getPoskod(form.lkp_bandar_id, 1)" 
                :validators="[validators.required]"
              />
              <z-select 
                class="form-field" 
                :items="lkp_daerah" 
                label="Daerah *"  
                v-model="form.lkp_daerah_id" 
                @input="getBandar(form.lkp_daerah_id, 1)" 
                :validators="[validators.required]"
              />
              <z-select 
                class="form-field" 
                :items="lkp_negeri" 
                label="Negeri *"  
                v-model="form.lkp_negeri_id" 
                @input="getDaerah(form.lkp_negeri_id, 1)" 
                :validators="[validators.required]"
              />
            </div>
          </div>
        </div>
        
        <!-- Action Buttons -->
        <div class="form-actions">
          
          <div class="close-button-container">
            <w-button 
              class="close-button" 
              @click="tutup"
            >
              TUTUP
            </w-button>
          </div>

          <div class="action-buttons">
            <w-tooltip md top color="white" bg-color="black">
              <template #activator="{ on }">
                <w-button 
                  class="action-button reset-button" 
                  v-on:click="resetPremis(1)"  
                  v-on="on" 
                  bg-color="warning"
                >
                  <w-icon md class="mr2">fal fa-redo</w-icon>SET SEMULA
                </w-button>
              </template>
              SET SEMULA
            </w-tooltip>
            
            <w-tooltip md top color="white" bg-color="black">
              <template #activator="{ on }">
                <w-button 
                  class="action-button save-button"  
                  v-on="on" 
                  type="submit" 
                  v-if="loading == 0"
                >
                  <w-icon md class="mr2">fal fa-save</w-icon>SIMPAN
                </w-button>
              </template>
              SIMPAN
            </w-tooltip>
            
            <w-tooltip md top color="white" bg-color="black">
              <template #activator="{ on }">
                <w-button 
                  class="action-button save-button" 
                  v-on="on" 
                  disabled="true" 
                  v-if="loading > 0"
                >
                  <w-icon md class="mr2">fal fa-save</w-icon>SIMPAN
                </w-button>
              </template>
              SIMPAN
            </w-tooltip>
          </div>
        </div>
      </w-form>
    </z-page>
    
    <!-- Search Dialog -->
    <w-dialog
      v-model="dialog.show"
      :fullscreen="dialog.fullscreen"
      :width="dialog.width"
      :persistent="dialog.persistent"
      :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-dark1--bg white"
    >
      <template #title>
        <w-icon class="mr2">fal fa-cog</w-icon>
        CARIAN ID PREMIS e-VETPERMIT
      </template>
      
      <w-form ref="form" v-model="dialog.valid" @validate="submit" @success="success">
        <div class="dialog-search-container">
          <w-input 
            class="dialog-search-input" 
            label="No Premis" 
            v-model="carian_profil.q"
          ></w-input>
          <w-button 
            class="dialog-search-button" 
            @click="cariProfil"
          >
            Cari
          </w-button>
        </div>
        
        <div class="table-container" v-if="cari_premis == 1">
          <table class="w-table" color="light">
            <thead>
              <tr>
                <th class="w-table__header text-left">No Premis</th>
                <th class="w-table__header text-left">Nama</th>
                <th class="w-table__header text-left">No Telefon</th>
                <th class="w-table__header text-left">Alamat</th>
                <th class="w-table__header text-center">Pilih</th>
              </tr>
            </thead>

            <tbody>
              <template v-if="damiList.length == 0">
                <tr class="w-table__row">
                  <td class="w-table__cell text-center" colspan="5">
                    Maklumat premis tidak ditemui... Sila rujuk pada pejabat veterinar negeri/daerah.
                  </td>
                </tr>
              </template>
              
              <template v-for="(dt, ind) in damiList">
                <tr class="w-table__row">
                  <td class="w-table__cell text-left">{{dt.no_premis}}</td>
                  <td class="w-table__cell text-left">{{dt.nama}}</td>
                  <td class="w-table__cell text-left">{{dt.no_tel}}</td>
                  <td class="w-table__cell text-left">{{dt.alamat}}</td>
                  <td class="w-table__cell text-center">
                    <template v-if="form.pembekal_id == dt.value">
                      <w-radio 
                        class="mr2" 
                        v-model="form.pembekal_id" 
                        @click="pilihProfil(dt)"
                      ></w-radio>
                    </template>
                    <template v-else>
                      <w-radio 
                        class="mr2" 
                        @click="pilihProfil(dt)"
                      ></w-radio>
                    </template>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </w-form>
      
      <template #actions>
        <div class="spacer" />
        <w-button 
          class="dialog-close-button" 
          @click="dialog.show = false"
        >
          TUTUP
        </w-button>
      </template>
    </w-dialog>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'daftar.premis',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Daftar Premis & Ternakan', route: '/daftar' },
        { label: 'Premis', route: '/daftar/premis' },
      ],
      title: 'Tambah Premis',
      form: {
        id: 0,
        alamat_id: 0,
        no_premis_vet: '',
        no_premis: '',
        nama: '',
        tarikh: '',
        emel: '',
        no_tel: '',
        alamat: '',
        kaedah_id: '',
        lkp_negeri_id: '',
        lkp_daerah_id: '',
        lkp_bandar_id: '',
        lkp_poskod_id: '',
        lkp_status_id: '',
        kode: '',
        p: 0,
        lkp_jenis_pengguna_id: '',
      },
      cari_premis: 0,
      kaedah: [],
      lkp_ternakan: [],
      lkp_baka: [],
      lkp_negara: [],
      lkp_gred: [],
      lkp_status: [],
      lkp_negeri: [],
      lkp_daerah: [],
      lkp_bandar: [],
      lkp_poskod: [],
      // jenis_pengguna: [],
      jenis_pengguna:[
        {value: 1, label: "KERAJAAN"},
        {value: 2, label: "SWASTA"}
      ],
      jantina: [],
      carian_profil: { q: "" },
      damiList: [],
      loading: 0,
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
    }
  },
  methods: {
    onSuccess() {
  this.loading = this.loading + 1;

  if (this.loading !== 1) return;
  if (this.form.id > 0) {
    this.$zcomm
      .update(this.resourceurl + '.update', this.form.id, this.form)
      .then(res => {
        if (typeof this.onAfterEdit === "function") {
          this.onAfterEdit();
        }

        this.$inertia.visit(
          this.$route('daftar.premis.show', this.form.id)
        );
      })
      .catch(error => {
        this.$zutil.notify(
          'Rekod Telah Wujud! Maklumat tidak disahkan kerana ID eVetPermit ini telah wujud dalam sistem AIMS.',
          false
        );

        setTimeout(() => {
          this.$inertia.visit(this.$route('daftar.premis.index'));
        }, 1500);

        console.error(error);
      });


  } else {
    this.$zcomm
      .post(this.resourceurl + '.store', this.form)
      .then(res => {
        if (typeof this.onAfterAdd === "function") {
          this.onAfterAdd();
        }

        this.$inertia.visit(
          this.$route('daftar.premis.show', res.id)
        );
      })
      .catch(error => {
        this.$zutil.notify(
          'Rekod Telah Wujud! Maklumat tidak disahkan kerana ID eVetPermit ini telah wujud dalam sistem AIMS.',
          false
        );

        setTimeout(() => {
          this.$inertia.visit(this.$route('daftar.premis.index'));
        }, 1500);

        console.error(error);
      });


  }
},



    getStatus() {
      this.$zcomm.get(this.api_service + 'lookup/status', {}).then(res => {
        this.lkp_status = res
      })
    },

    getNegeri() {
      this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
        this.lkp_negeri = res
      })
    },

    getKaedah() {
      this.$zcomm.get(this.api_service + 'lookup/kaedah', {}).then(res => {
        this.kaedah = res
      })
    },

    getDaerah(i, p) {
      this.form.p = parseInt(p)
      this.$zcomm.get(this.api_service + 'lookup/daerah/' + i, {}).then(res => {
        this.lkp_daerah = res
      })
    },

    getBandar(i, p) {
      this.form.p = parseInt(p)
      this.$zcomm.get(this.api_service + 'lookup/bandar/' + i, {}).then(res => {
        this.lkp_bandar = res
      })
    },

    // getlkpJenisPengguna() {
    //   this.$zcomm.get(this.api_service + 'lookup/jenis_pengguna', {}).then(res => {
    //     this.jenis_pengguna = res
    //   })
    // },

    getPoskod(i, p) {
      this.form.p = parseInt(p)
      this.$zcomm.get(this.api_service + 'lookup/poskod/' + i, {}).then(res => {
        this.lkp_poskod = res
      })
    },

    getBandarPoskod(id) {
      this.form.lkp_bandar_id == '';
      this.$zcomm.get(this.api_service + 'lookup/bandar_poskod/' + this.form.lkp_poskod_id, {}).then(res => {
        this.bandar = res
      })
    },

    resetPremis(item) {
      this.$inertia.visit(this.$page.url)
    },

    pilihProfil(dt) {
      this.form.no_premis_vet = dt.no_premis
      this.form.nama = dt.nama
      this.form.no_tel = dt.no_tel
      this.form.alamat = dt.alamat
      this.form.kode = dt.kode,
      this.form.lkp_kaedah_id = dt.kaedah_id
      this.dialog.show = false
      this.getPoskodUtama()
    },

    tutup() {
      this.$inertia.visit(window.route('daftar.premis.index'));
    },

    getPoskodUtama() {
      if (this.form.kode.length == 5) {
        this.$zcomm.get(this.api_service + 'lookup/poskod_utama/' + this.form.kode, {}).then(res => {
          if (res.lkp_bandar_id) {
            this.$zcomm.get(this.api_service + 'lookup/poskod/' + res.lkp_bandar_id, {}).then(r => {
              this.lkp_poskod = r
              this.form.lkp_poskod_id = res.lkp_poskod_id
            })
            this.$zcomm.get(this.api_service + 'lookup/bandar/' + res.lkp_daerah_id, {}).then(r => {
              this.lkp_bandar = r
              this.form.lkp_bandar_id = res.lkp_bandar_id
            })
            this.$zcomm.get(this.api_service + 'lookup/daerah/' + res.lkp_negeri_id, {}).then(r => {
              this.lkp_daerah = r
              this.form.lkp_daerah_id = res.lkp_daerah_id
            })
            this.form.lkp_negeri_id = res.lkp_negeri_id
          }
        })
      }
    },

    cariPremis() {
      this.cari_premis = 0
      this.dialog.show = true;
      this.cariProfil()
    },

    cariProfil() {
      if (this.carian_profil.q.length > 1) {
        this.$zcomm
          .get(
            this.api_service + "lookup/premis_integrasi",
            this.carian_profil
          )
          .then((res) => {
            this.damiList = res;
            this.cari_premis = 1
          });
      } else {
        alert('sila lengkapkan no premis sebelum cari')
      }
    },

    getData() {
      if (this.id > 0) {
        this.$zcomm.get(this.api_service + 'premis/show/' + this.id, {}).then(res => {
          if (res.lkp_negeri_id > 0) {
            this.getDaerah(res.lkp_negeri_id, 1)
          }
          if (res.lkp_daerah_id > 0) {
            this.getBandar(res.lkp_daerah_id, 1)
          }
          if (res.lkp_bandar_id > 0) {
            this.getPoskod(res.lkp_bandar_id, 1)
          }
          this.form = res
        })
      }
    },
  },

  watch: {

  },
  mounted() {
    if (this.id > 0) {
      this.title = 'Kemaskini Premis'
    } else {
      this.title = 'Tambah Premis'
    }

    this.getNegeri()
    this.getStatus()
    this.getData()
    this.getKaedah()
    // this.getlkpJenisPengguna()
  }
}
</script>

<style scoped>
/* Search Section Styles */
.search-section {
  background-color: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.search-container {
  max-width: 800px;
}

.search-title {
  color: #e63946;
  font-weight: 600;
  font-size: 1.1rem;
  line-height: 1.5;
  margin-bottom: 1.5rem;
}

.search-input-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-input {
  flex: 1;
}

.search-button {
  background-color: #397ee6;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 10px rgba(57, 126, 230, 0.47);
}

.search-button:hover {
  background-color: #2968c6;
  transform: scale(1.05);
}

/* Form Styles */
.premis-form {
  padding: 1rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.form-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.card-header {
  background-color: #f0f4f8;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.card-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
}

.card-body {
  padding: 1.5rem;
}

.form-field {
  margin-bottom: 1.25rem;
}

.field-label {
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #1e3a8a;
}

.field-input {
  margin-top: 0.5rem;
}

/* Action Buttons Styles */
.form-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
}

.action-buttons {
  display: flex;
  gap: 0.75rem;
}

.action-button {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.25rem;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.reset-button {
  background-color: #f6ad55;
  color: #fff;
}

.reset-button:hover {
  background-color: #ed8936;
}

.save-button {
  background-color: #4299e1;
  color: #fff;
}

.save-button:hover {
  background-color: #3182ce;
}

.close-button-container {
  /*margin-left: auto;*/
}

.close-button {
  background-color: #f7fafc;
  border: 2px solid #e53e3e;
  color: #333;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.close-button:hover {
  background-color: #fed7d7;
}

/* Dialog Styles */
.dialog-search-container {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.dialog-search-input {
  flex: 1;
}

.dialog-search-button {
  background-color: #4299e1;
  color: white;
  border-radius: 4px;
  padding: 0 1.5rem;
}

.table-container {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
}

.dialog-close-button {
  background-color: #f7fafc;
  border: 2px solid #e53e3e;
  color: #333;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .form-actions {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  
  .action-buttons {
    justify-content: center;
  }
  
  .close-button-container {
    margin-left: 0;
    text-align: center;
  }
  
  .dialog-search-container {
    flex-direction: column;
  }
}
</style>